import { ResponseModel } from "../model/response/ResponseModel";
import { OnlineMenuModel } from "../model/response/OnlineMenuResponseModel";
import api from "../Api";
import { ApiPath } from "../ApiPath";

const VerifyService = () => {
  const subDomain = window.location.href.includes("localhost:")
    ? "demo"
    : window.location.href.replaceAll("https://", "").replaceAll("http://", "").split(".")[0];

  const subDomainParams = new URLSearchParams({
    title: subDomain
  });

  function sendVerify(orderID: string, verifyCode: string) {
    const err = { error: true } as ResponseModel<OnlineMenuModel>;
    return api()
      .post<ResponseModel<any>>(`${ApiPath.sendVerify}?${subDomainParams}`, {
        requestModel: {
          key: orderID,
          code: verifyCode
        }
      })
      .then((value) => {
        if (value.data.statusCode === 1000) {
          return value.data.responseModel;
        } else {
          return err;
        }
      })
      .catch(() => {
        return err;
      });
  }

  return {
    sendVerify
  };
};
export default VerifyService;
